export const CertificateStatus = {
  LIVE: "live",
  OFFICIAL: "official"
}


// WEBPACK FOOTER //
// ./src/enums/CertificateStatus.js